export const isAbsoluteLink = (link: string | null): boolean => {
  return !!link && link.includes('://');
};
